module.exports = __webpack_public_path__ + "img/SEO-Suite-logo.72bc474f.jpg";